<template>
  <div>
    <b-table
      :fields="fields"
      :items="items"
      bordered
      hover
      v-resizable-columns="{
        tableId: 'example-table-1',
        minWidth: 80,
        maxWidth: 600,
        exclude: ['actions'],
      }"
      :busy="loading"
    >
      <template v-slot:table-busy>
        <vcl-table
          :speed="5"
          :animate="true"
          :columns="10"
        />
      </template>

      <template v-slot:cell(name)="row">
        <span class="d-inline-flex align-items-center">
          <!-- NCC phụ (child): click → query theo id (id = NCC chính) -->
          <span
            v-if="row.item.parentId != null"
            v-b-tooltip.hover
            title="Nhà cung cấp phụ - Click để xem NCC chính"
            class="mr-1 text-info cursor-pointer provider-parent-icon"
            @click.stop="
              $emit('filter-by-parent', {
                queryBy: 'id',
                id: row.item.parentId,
                name: row.item.parentName || row.item.parent?.name,
              })
            "
          >
            <i
              class="fas fa-code-branch"
              style="font-size: 0.9rem"
            ></i>
          </span>
          <!-- NCC chính (parent): click → query theo parentId (lấy danh sách NCC phụ) -->
          <span
            v-else
            v-b-tooltip.hover
            title="Tìm các nhà cung cấp phụ của nhà cung cấp này"
            class="mr-1 text-primary cursor-pointer provider-parent-icon"
            @click.stop="
              $emit('filter-by-parent', {
                queryBy: 'parentId',
                id: row.item.id,
                name: row.item.name,
              })
            "
          >
            <i
              class="fas fa-building"
              style="font-size: 0.9rem"
            ></i>
          </span>
          <a
            :href="`#/providers/update-provider?id=${row.item.id}`"
            :aria-label="`Xem chi tiết nhà cung cấp ${row.item.name}`"
            class="font-weight-bold"
          >
            {{ row.item.name }}
          </a>
        </span>
        <br />
        <span v-if="row.item.code">
          Mã: <span class="font-weight-bold text-warning">{{ row.item.code }}</span>
        </span>
      </template>

      <template v-slot:cell(email)="row">
        <i
          class="fas fa-phone mr-1"
          style="font-size: 1rem"
        ></i>
        <span
          v-if="row.item.phoneNo"
          class="text-right"
          >{{ row.item.phoneNo }}</span
        >
        <br />
        <span v-if="row.item.email">
          <i
            class="fas fa-envelope mr-1"
            style="font-size: 1rem"
          ></i>
          <span>{{ row.item.email }}</span>
        </span>
      </template>

      <template v-slot:cell(type)="row">
        <span v-if="checkType(row.item)">
          <span class="label label-dot label-primary mr-2"></span>
          <span class="font-bold font-primary">{{ row.item.type }}</span>
        </span>
        <span v-else>
          <span
            v-if="row.item.type"
            class="label label-dot label-success mr-2"
          ></span>
          <span class="font-bold font-success">{{ row.item.type }}</span>
        </span>
      </template>

      <template v-slot:cell(status)="row">
        <span
          v-if="checkStatus(row.item)"
          class="label font-weight-bold label-lg label-light-success label-inline"
        >
          {{ row.item.statusName }}
        </span>
        <span v-else>
          <span
            v-if="row.item.status"
            class="label font-weight-bold label-lg label-light-danger label-inline"
          >
            {{ row.item.statusName }}
          </span>
        </span>
      </template>

      <template v-slot:cell(actions)="row">
        <div class="d-flex justify-content-center">
          <b-dropdown
            size="sm"
            id="dropdown-left"
            no-caret
            right
          >
            <template slot="button-content">
              <i
                style="font-size: 1rem; padding-right: 0px"
                class="flaticon2-settings"
              ></i>
            </template>
            <b-dropdown-item
              @click="editItem(row.item)"
              v-if="!checkViewOnly()"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem"
                  class="flaticon2-pen"
                ></i>
                &nbsp; Xem chi tiết
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="false"
              @click="showDeleteAlert(row.item)"
              v-show="checkPermission('PROVIDER_DELETE')"
            >
              <span style="color: #3f4254; font-size: 12px">
                <i
                  style="font-size: 1rem; color: #d33"
                  class="flaticon2-rubbish-bin-delete-button"
                ></i>
                &nbsp; Xóa
              </span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import ResizableTableMixin from '@/mixins/ResizableTableMixin'
import { VclTable } from 'vue-content-loading'
import localData from '../../../../utils/saveDataToLocal'

export default {
  name: 'ProviderListTable',
  components: {
    VclTable,
  },
  mixins: [ResizableTableMixin],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {}
  },

  mounted() {
    this.$nextTick(() => {
      this.initResizableColumns('example-table-3')
    })
  },

  methods: {
    handleAction(item) {
      console.log('Action clicked for:', item)
    },

    resetColumnWidths() {
      ;['example-table-3'].forEach((tableId) => {
        localStorage.removeItem(`table_column_widths_${tableId}`)
      })
      this.$router.go()
    },

    checkViewOnly() {
      let count = 0
      if (localData.checkPermission('PROVIDER_VIEW')) {
        count++
      }
      if (localData.checkPermission('PROVIDER_UPDATE')) {
        count++
      }
      return count === 1
    },

    checkPermission(condition) {
      return localData.checkPermission(condition)
    },

    editItem(item) {
      this.$emit('edit-item', item)
    },

    showDeleteAlert(item) {
      this.$emit('delete-item', item)
    },

    checkStatus(item) {
      return item.status === 1
    },

    checkType(item) {
      return item.type === 'Cá nhân'
    },
  },
}
</script>

<style lang="scss" scoped>
.resizable-table-example {
  .controls {
    display: flex;
    gap: 10px;
  }
}
.provider-parent-icon:hover {
  opacity: 0.8;
}
.cursor-pointer {
  cursor: pointer;
}
</style> 
